import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tooted, mida kohe ei soovi või ei saa soetada on hea hoida soovinimekirjas. Kasuta võimalust ja lisa tooted enda lemmikuks, et nad kaotsi ei läheks!

  <span style="color:#85c1dc;">**FI:**</span>
  Jatka eteenpäin siitä mihin jäit ja tarkista toivelistasi tuotteet.

  <span style="color:#85c1dc;">**RU:**</span>
  Продолжите свой путь с того места, на котором остановились, и просмотрите продукты в своем списке желаний.
*/
/* @__NO_SIDE_EFFECTS__ */
const m284 = msg(
  mf`Tooted, mida kohe ei soovi või ei saa soetada on hea hoida soovinimekirjas. Kasuta võimalust ja lisa tooted enda lemmikuks, et nad kaotsi ei läheks!`,
  mf`Jatka eteenpäin siitä mihin jäit ja tarkista toivelistasi tuotteet.`,
  mf`Продолжите свой путь с того места, на котором остановились, и просмотрите продукты в своем списке желаний.`,
)

export { m284 as 'w.basket.empty.first.text' }